import React, { useEffect } from "react";
import { bool, element, func, string } from "prop-types";
import { connect } from "react-redux";

import { dialogueShow } from "../../helper/actions";

import "./dialogue.m.css";

const Dialogue = ({ children, dialogueShow, width = "80%" }) => {
  useEffect(() => {
    return () => {
      dialogueShow(false);
    };
  }, []);

  return (
    <div styleName="dialogue-view" onClick={() => dialogueShow(false)}>
      <div style={{ width: width }} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

Dialogue.propTypes = {
  show: bool,
  dialogueShow: func,
  children: element,
  width: string,
};

const mapDispatchToProps = (dispatch) => ({
  dialogueShow: (show) => dispatch(dialogueShow(show)),
});

export default connect(null, mapDispatchToProps)(Dialogue);
